import React from "react";
import "./IncentivesBundles.css";
import { useState } from "react";
import {
  ArrowRight,
  ArrowUpRight,
  Info,
  X,
  Search,
  Calendar,
  Check,
  Pause,
  Trash2,
  ChevronLeft,
  ChevronRight,
  Users,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ComposedChart,
  BarChart,
  Bar,
  Cell,
  Line,
} from "recharts";
import { FiMoreVertical } from "react-icons/fi";
import "react-circular-progressbar/dist/styles.css";
import TotalVouchersIcon from "../../../assets/svg/Group 163015.svg";
import RevenueIcon from "../../../assets/svg/wallet (1) 1.svg";
import ConversionRate from "../../../assets/svg/trend 1.svg";
import AverageBundlePriceIcon from "../../../assets/svg/Vector (3).svg";
import ActiveIcon from "../../../assets/svg/Vector (1).svg";
import ScheduledIcon from "../../../assets/svg/calendar 1.svg";
import DraftIcon from "../../../assets/svg/draft 1.svg";
import UnderReviewIcon from "../../../assets/svg/clock (3) 1.svg";
import PausedIcon from "../../../assets/svg/pause-circle-svgrepo-com 1.svg";
import ApprovedIcon from "../../../assets/svg/shield-check-svgrepo-com 1 (1).svg";
import ExpiredIcon from "../../../assets/svg/support 1.svg";
import ArchivedIcon from "../../../assets/svg/Archived.svg";
import OmarAvatar from "../../../assets/svg/alert2 1.svg";
// Bundle category icons (تستخدم في Top Revenue/Profit/Conversion/Sales)
import iconMaintenance from "../../../assets/svg/fix-svgrepo-com 1 (2).svg";
import iconCarCare from "../../../assets/svg/Car Care Outside.svg";
import iconOil from "../../../assets/svg/ChangeOil.svg";
import iconTire from "../../../assets/svg/Tire.svg";
// AI Insights icons
import iconTrophy from "../../../assets/svg/trophy-svgrepo-com 2.svg";
import iconTarget from "../../../assets/svg/target 2.svg";
import iconTiers from "../../../assets/svg/tiers-svgrepo-com 1.svg";
// Alerts icons (كل واحدة لونها مختلف زي الصورة، فلازم 4 صور منفصلة ملونة)
import iconAlertExpiry from "../../../assets/svg/Alert triangle (4).svg";
import iconAlertBudget from "../../../assets/svg/Alert triangle (1).svg";
import iconAlertProvider from "../../../assets/svg/Alert triangle (2).svg";
import iconAlertInventory from "../../../assets/svg/Alert triangle (3).svg";
// Lowest Performing icons
import iconBattery from "../../../assets/svg/Icon.svg";
import iconRain from "../../../assets/svg/rain 1.svg";
import iconSheep from "../../../assets/svg/sheep 1.svg";
import iconMaintenanceSmall from "../../../assets/svg/Icon (5).svg";
import { useNavigate } from "react-router";

export default function IncentivesBundles() {

  const navigate = useNavigate();
  //  ****************************************************************************

  // stats
  const stats = [
    {
      title: "Total Bundles",
      value: "256",
      icon: TotalVouchersIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Revenue Generated",
      value: "3,245,780 EGP",
      icon: RevenueIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Conversion Rate",
      value: "18.6%",
      icon: ConversionRate,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Average Bundle Price",
      value: "868 EGP",
      icon: AverageBundlePriceIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Active",
      value: "148",
      icon: ActiveIcon,
      bg: "#3FBEAC",
      iconColor: "#14B8A6",
      trend: "+8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Scheduled",
      value: "28",
      icon: ScheduledIcon,
      bg: "#7E1BAD",
      iconColor: "#A855F7",
      trend: "+14%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Draft",
      value: "34",
      icon: DraftIcon,
      bg: "#8CB369",
      iconColor: "#65A30D",
      trend: null,
      trendType: "neutral",
      subtitle: "In progress",
    },
    {
      title: "Under Review",
      value: "18",
      icon: UnderReviewIcon,
      bg: "#FEB91E",
      iconColor: "#F59E0B",
      trend: null,
      trendType: "neutral",
      subtitle: "In review",
    },
    {
      title: "Paused",
      value: "6",
      icon: PausedIcon,
      bg: "#FC6C4F",
      iconColor: "#F43F5E",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Approved",
      value: "42",
      icon: ApprovedIcon,
      bg: "#3E9FF6",
      iconColor: "#FFFFFF",
      trend: "8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Expired",
      value: "46",
      icon: ExpiredIcon,
      bg: "#696969",
      iconColor: "#FFFFFF",
      trend: "-5%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Archived",
      value: "12",
      icon: ArchivedIcon,
      bg: "#04B22E",
      iconColor: "#FFFFFF",
      trend: "9%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
  ];

  // Bundles Performance
  const bundlesPerformance = [
    {
      title: "Units Sold ",
      value: "12,458",
      icon: Users,
      trend: "+18%",
      color: "#111827",
    },
    {
      title: "Revenue Generated",
      value: "1,250,000 EGP",
      icon: Check,
      trend: "+18%",
      color: "#14B8A6",
    },
    {
      title: "Avg. Order Value",
      value: "750 EGP",
      icon: X,
      trend: "+18%",
      color: "#DC2626",
    },
    {
      title: "Conversion Rate",
      value: "18.6%",
      icon: Users,
      trend: "+18%",
      color: "#7C3AED",
    },
    {
      title: "Total Customer Savings",
      value: "186,000",
      icon: Users,
      trend: "+18%",
      color: "#7C3AED",
    },
  ];

  // filters
  const [isFiltersOpen, setIsFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [filters, setFilters] = useState({
    category: "All Categories",
    type: "All Types",
    fundingSource: "All Sources",
    providers: "All Providers",
    assignmentType: "All Assignments",
    priority: "All Priorities",
    createdBy: "All Users",
    priceRange: "Min - Max",
    revenueRange: "Min - Max",
    conversionRate: "Min % - Max %",
    dateRange: "May 01, 2025 - May 31, 2025",
  });

  const filterFieldsRow1 = [
    { key: "category", label: "Bundle Category", value: filters.category },
    { key: "type", label: "Bundle Type", value: filters.type },
    {
      key: "fundingSource",
      label: "Funding Source",
      value: filters.fundingSource,
    },
    { key: "providers", label: "Providers", value: filters.providers },
    {
      key: "assignmentType",
      label: "Assignment Type",
      value: filters.assignmentType,
    },
  ];

  const filterFieldsRow2 = [
    { key: "priority", label: "Priority", value: filters.priority },
    { key: "createdBy", label: "Created By", value: filters.createdBy },
    { key: "priceRange", label: "Price Range", value: filters.priceRange },
    {
      key: "revenueRange",
      label: "Revenue Range",
      value: filters.revenueRange,
    },
    {
      key: "conversionRate",
      label: "Conversion Rate",
      value: filters.conversionRate,
    },
  ];

  const handleClearAll = () => {
    setFilters({
      category: "All Categories",
      type: "All Types",
      fundingSource: "All Sources",
      providers: "All Providers",
      assignmentType: "All Assignments",
      priority: "All Priorities",
      createdBy: "All Users",
      priceRange: "Min - Max",
      revenueRange: "Min - Max",
      conversionRate: "Min % - Max %",
      dateRange: "May 01, 2025 - May 31, 2025",
    });
    setSearchTerm("");
  };

  // table & tabs
  const voucherTabs = [
    { key: "all", label: "All Bundles", count: 256 },
    { key: "active", label: "Active", count: 148 },
    { key: "scheduled", label: "Scheduled", count: 28 },
    { key: "draft", label: "Draft", count: 34 },
    { key: "underReview", label: "Under Review", count: 18 },
    { key: "paused", label: "Paused", count: 6 },
    { key: "expired", label: "Expired", count: 46 },
    { key: "disabled", label: "Disabled", count: 12 },
  ];

  const statusStyles = {
    Active: { bg: "#E6F7F4", color: "#14B8A6" },
    Scheduled: { bg: "#F3E8FF", color: "#A855F7" },
    Draft: { bg: "#EFFCE9", color: "#65A30D" },
  };

  const vouchersData = [
    {
      id: "PRM-001",
      name: "Welcome 20% Off",
      code: "Welcome 20%",
      type: "Percentage",
      discount: "20% OFF",
      assignedTo: "All Customers",
      redemptionUsed: 1245,
      redemptionLimit: 5000,
      validity: "Mar 10 - May 31, 2025",
      status: "Active",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-002",
      name: "Ramadan Special 25%",
      code: "RAMADAN25",
      type: "Percentage",
      discount: "25% OFF",
      assignedTo: "VIP Customers",
      redemptionUsed: 2890,
      redemptionLimit: 10000,
      validity: "Mar 20 - Jun 20, 2025",
      status: "Scheduled",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-003",
      name: "Free Shipping",
      code: "FREESHIP",
      type: "Fixed amount",
      discount: "Free Shipping",
      assignedTo: "All Customers",
      redemptionUsed: 856,
      redemptionLimit: null,
      validity: "Mar 01 - May 31, 2025",
      status: "Active",
      lastUpdate: "3h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-004",
      name: "New User 15% Off",
      code: "NEWUSER15",
      type: "Percentage",
      discount: "15% OFF",
      assignedTo: "New Customers",
      redemptionUsed: 562,
      redemptionLimit: 2000,
      validity: "-",
      status: "Draft",
      lastUpdate: "1d ago",
      updatedBy: "Mona Ali",
    },
  ];

  const [activeVoucherTab, setActiveVoucherTab] = useState("all");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [voucherPage, setVoucherPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const totalVouchersCount = 256;

  const filteredVouchers =
    activeVoucherTab === "all"
      ? vouchersData
      : vouchersData.filter(
          (v) => v.status.toLowerCase() === activeVoucherTab.toLowerCase(),
        );

  const totalPages = Math.max(1, Math.ceil(totalVouchersCount / perPage));

  const startIndex = (voucherPage - 1) * perPage;

  const currentPageData = filteredVouchers.slice(
    startIndex,
    startIndex + perPage,
  );

  const allSelected =
    currentPageData.length > 0 &&
    currentPageData.every((v) => selectedRows.has(v.id));

  const toggleRow = (id) => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (allSelected) {
        currentPageData.forEach((v) => next.delete(v.id));
      } else {
        currentPageData.forEach((v) => next.add(v.id));
      }
      return next;
    });
  };

  const getPageNumbers = (current, total) => {
    const pages = [];
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    pages.push(1, 2, 3, "...", total);
    return pages;
  };

  const pageNumbers = getPageNumbers(voucherPage, totalPages);
  const activeTabLabel =
    voucherTabs.find((t) => t.key === activeVoucherTab)?.label ||
    "All Vouchers";

  // ===== Overview Cards (Row 1) =====
  const overviewMetrics = [
    {
      title: "Average Bundle Size",
      value: "2.4",
      suffix: "Services",
      trend: "+8%",
    },
    { title: "Upsell Rate", value: "12.8%", suffix: null, trend: "+8%" },
    { title: "Cross-sell Rate", value: "18.6%", suffix: null, trend: "+8%" },
    {
      title: "Repeat Purchase Rate",
      value: "27.3%",
      suffix: null,
      trend: "+8%",
    },
  ];

  // ===== Top Revenue / Profit / Conversion / Sales =====
  const topRevenue = [
    {
      icon: iconMaintenance,
      bg: "#F4F8F0",
      name: "10 Maintenance Bundle",
      value: "374,400 EGP",
    },
    {
      icon: iconCarCare,
      bg: "#F0F8FF",
      name: "Car Care Bundle",
      value: "234,000 EGP",
    },
    {
      icon: iconOil,
      bg: "#FFFAEA",
      name: "Oil Change Bundle",
      value: "122,000 EGP",
    },
    {
      icon: iconTire,
      bg: "#F8F8F8",
      name: "Tire Care Bundle",
      value: "98,000 EGP",
    },
  ];

  const topProfit = [
    {
      icon: iconMaintenance,
      bg: "#F4F8F0",
      name: "10 Maintenance Bundle",
      value: "374,400 EGP",
    },
    {
      icon: iconCarCare,
      bg: "#F0F8FF",
      name: "Car Care Bundle",
      value: "234,000 EGP",
    },
    {
      icon: iconOil,
      bg: "#FFFAEA",
      name: "Oil Change Bundle",
      value: "122,000 EGP",
    },
    {
      icon: iconTire,
      bg: "#F8F8F8",
      name: "Tire Care Bundle",
      value: "98,000 EGP",
    },
  ];

  const topConversion = [
    {
      icon: iconMaintenance,
      bg: "#F4F8F0",
      name: "10 Maintenance Bundle",
      value: "22.4%",
    },
    {
      icon: iconCarCare,
      bg: "#F0F8FF",
      name: "Car Care Bundle",
      value: "18.6%",
    },
    { icon: iconOil, bg: "#FFFAEA", name: "Oil Change Bundle", value: "15.2%" },
    { icon: iconTire, bg: "#F8F8F8", name: "Tire Care Bundle", value: "9.8%" },
  ];

  const topSales = [
    {
      icon: iconMaintenance,
      bg: "#F4F8F0",
      name: "10 Maintenance Bundle",
      value: "432",
    },
    { icon: iconCarCare, bg: "#F0F8FF", name: "Car Care Bundle", value: "312" },
    { icon: iconOil, bg: "#FFFAEA", name: "Oil Change Bundle", value: "245" },
    { icon: iconTire, bg: "#F8F8F8", name: "Tire Care Bundle", value: "198" },
  ];

  const lowestPerforming = [
    {
      icon: iconBattery,
      name: "Battery + Installation",
      conversion: "2.1%",
      reasonLabel: "Low Conversion",
      reasonColor: "#A80101",
      reasonBg: "#FFF4F0",
    },
    {
      icon: iconRain,
      name: "Winter Care Bundle",
      conversion: "2.8%",
      reasonLabel: "Budget Issue",
      reasonColor: "#C98C04",
      reasonBg: "#FFFAEA",
    },
    {
      icon: iconSheep,
      name: "Eid Al-Adha Offer",
      conversion: "3.6%",
      reasonLabel: "Provider Issue",
      reasonColor: "#0879DE",
      reasonBg: "#F0F8FF",
    },
    {
      icon: iconMaintenanceSmall,
      name: "Basic Maintenance",
      conversion: "4.1%",
      reasonLabel: "Low Conversion",
      reasonColor: "#A80101",
      reasonBg: "#FFF4F0",
    },
  ];

  // ===== Alerts =====
  const bundleAlerts = [
    {
      icon: iconAlertExpiry,
      bg: "#FFFAEA",
      title: "Bundle Near Expiry",
      desc: "8 bundles will expire in next 7 days",
    },
    {
      icon: iconAlertBudget,
      bg: "#FFF4F0",
      title: "Bundle almost finished",
      desc: "3 bundles have less than 10% budget remaining",
    },
    {
      icon: iconAlertProvider,
      bg: "#F0F8FF",
      title: "Provider Issue",
      desc: "3 bundles have provider assignment issues",
    },
    {
      icon: iconAlertInventory,
      bg: "#F6E9FC",
      title: "Inventory conflict",
      desc: "2 bundles have inventory issues",
    },
  ];

  // ===== AI Insights =====
  const aiInsights = [
    {
      icon: iconTrophy,
      bg: "#ECF9F7",
      label: "Best Performing Bundle",
      title: "10K Maintenance Bundle",
      sub: "Revenue: 1.3M EGP",
    },
    {
      icon: iconTarget,
      bg: "#FFF4F0",
      label: "Suggested Target Segment",
      title: "Target Segment: SUV Owners",
      sub: "High potential segment",
    },
    {
      icon: iconTiers,
      bg: "#FFFAEA",
      label: "Cross-selling Opportunity",
      title: 'Add "Tire Rotation" Service',
      sub: "Could increase ACV by 12%",
    },
  ];

  // ===== Bundle Performance Trend chart =====
  const trendData = [
    { name: "Apr 22", revenue: 40000 },
    { name: "Apr 25", revenue: 90000 },
    { name: "Apr 29", revenue: 175000 },
    { name: "May 02", revenue: 110000 },
    { name: "May 06", revenue: 70000 },
    { name: "May 09", revenue: 85000 },
    { name: "May 13", revenue: 195000 },
    { name: "May 16", revenue: 60000 },
    { name: "May 20", revenue: 45000 },
  ];

  const trendTabs = ["Revenue", "Orders", "Customers", "Profit", "Savings"];

  // ===== Recent Activity =====
  const recentActivity = [
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Bundle",
      bundle: "10K Maintenance Bundle",
      date: "Jun 15, 2025 10:30 am",
      source: "System",
      details: "Bundle created with 4 services and 27% discount",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Bundle",
      bundle: "10K Maintenance Bundle",
      date: "Jun 15, 2025 10:30 am",
      source: "System",
      details: "Bundle created with 4 services and 27% discount",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Bundle",
      bundle: "10K Maintenance Bundle",
      date: "Jun 15, 2025 10:30 am",
      source: "System",
      details: "Bundle created with 4 services and 27% discount",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Bundle",
      bundle: "10K Maintenance Bundle",
      date: "Jun 15, 2025 10:30 am",
      source: "System",
      details: "Bundle created with 4 services and 27% discount",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Bundle",
      bundle: "10K Maintenance Bundle",
      date: "Jun 15, 2025 10:30 am",
      source: "System",
      details: "Bundle created with 4 services and 27% discount",
    },
  ];

  // ===== Bundle Health (donut) =====
  const bundleHealthData = [
    { label: "Active", count: 148, pct: 57.8, color: "#3FBEAC" },
    { label: "Scheduled", count: 34, pct: 10.9, color: "#7E1BAD" },
    { label: "Draft", count: 42, pct: 13.3, color: "#8CB369" },
    { label: "Under Review", count: 22, pct: 7.0, color: "#FEB91E" },
    { label: "Paused", count: 7, pct: 2.3, color: "#FC6C4F" },
    { label: "Expired", count: 19, pct: 6.2, color: "#696969" },
    { label: "Approved", count: 15, pct: 4.7, color: "#3E9FF6" },
    { label: "Archived", count: 20, pct: 1.2, color: "#04B22E" },
  ];
  const bundleHealthTotal = 312;

  // ===== Bundle Performance by Sales (bar chart) =====
  const bundlesBySalesData = [
    { name: "10K Maintenance Bundle", value: 432, color: "#8CB369" },
    { name: "Car Care Bundle", value: 312, color: "#3E9FF6" },
    { name: "Oil Change Bundle", value: 245, color: "#FEB91E" },
    { name: "Tire Care Bundle", value: 198, color: "#696969" },
  ];

  // ===== Bundles by Category (donut) =====
  const bundlesByCategoryData = [
    { label: "Maintenance", pct: 33.3, color: "#8CB369" },
    { label: "Car Care", pct: 23.8, color: "#3E9FF6" },
    { label: "Oil", pct: 17.1, color: "#FEB91E" },
    { label: "Tires", pct: 11.4, color: "#696969" },
    { label: "Batteries", pct: 10.8, color: "#FC6C4F" },
  ];
  const bundlesByCategoryTotal = 312;

  // Reuse the buildConicGradient helper you already have
  const buildConicGradient = (segments) => {
    let acc = 0;
    const stops = segments.map((s) => {
      const start = acc;
      acc += s.pct;
      return `${s.color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  // ****************************************************************************

  return (
    <div className="voucher-page-wrapper">
      <div className="voucher-overview">
        {/* HEADER */}
        <div className="voucher-header">
          <div className="voucher-header-left">
            <h3>Bundles</h3>
            <p>Track bundles performance and effectiveness.</p>
          </div>
          <div className="header-right">
            <button className="incentive-btn create">
              <i className="fa-solid fa-plus"></i>
              Create Bundle
            </button>
            <button className="incentive-btn light">
              <i className="fa-solid fa-download"></i>
              Export
            </button>
          </div>
        </div>
        {/* STATS */}
        <div className="vouchers-stats-grid">
          {stats.map((item, i) => (
            <div className="vouchers-stat-card" key={i}>
              <div className="vouchers-stat-top-bundles">
                <div
                  className="vouchers-stat-icon"
                  style={{ backgroundColor: item.bg }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="vouchers-stat-icon-img"
                  />
                </div>
                <span className="vouchers-stat-title">{item.title}</span>
              </div>

              <div className="vouchers-stat-value-bundles">{item.value}</div>

              <div className="vouchers-stat-bottom">
                {item.trend ? (
                  <>
                    <span
                      className={`vouchers-trend vouchers-trend-${item.trendType}`}
                    >
                      {item.trend}
                    </span>
                    <span className="vouchers-trend-text">{item.subtitle}</span>
                  </>
                ) : (
                  <span className="vouchers-trend-text">{item.subtitle}</span>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* Bundles Performance */}
        <div className="vi-card mt-4">
          <h4 className="vi-card-title">
            Bundles Performance <span>(Last 30 Days)</span>{" "}
          </h4>
          <div className="bundles-impact-grid">
            {bundlesPerformance.map((item, i) => (
              <div className="bi-item" key={i}>
                <div
                  className="bi-icon-circle"
                  style={{ backgroundColor: item.color }}
                >
                  <item.icon size={16} color="#fff" />
                </div>
                <div className="bi-content">
                  <span className="bi-label">{item.title}</span>
                  <div className="bi-value">{item.value}</div>
                  <div className="bi-trend">
                    <span className="bi-trend-arrow">
                      <ArrowUpRight size={10} />
                    </span>
                    <span className="bi-trend-pct">{item.trend}</span>
                    <span className="bi-trend-text">vs last 30 days</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* filters */}
        <div className="bf-wrapper my-3">
          <div className="bf-top-row">
            <div className="bf-search-box">
              <Search size={16} className="bf-search-icon" />
              <input
                type="text"
                placeholder="Search by bundle name, ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="bf-search-input"
              />
            </div>
            <div className="bf-actions">
              <button className="bf-clear-all" onClick={handleClearAll}>
                Clear all
              </button>
              <button
                className="bf-toggle-btn"
                onClick={() => setIsFiltersOpen((prev) => !prev)}
              >
                Filters
                {isFiltersOpen ? (
                  <ChevronUp size={14} />
                ) : (
                  <ChevronDown size={14} />
                )}
              </button>
            </div>
          </div>

          {isFiltersOpen && (
            <div className="bf-body">
              <div className="bf-grid-row">
                {filterFieldsRow1.map((field) => (
                  <div className="bf-field" key={field.key}>
                    <label className="bf-field-label">{field.label}</label>
                    <button className="bf-dropdown">
                      <span>{field.value}</span>
                      <ChevronDown size={14} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="bf-grid-row">
                {filterFieldsRow2.map((field) => (
                  <div className="bf-field" key={field.key}>
                    <label className="bf-field-label">{field.label}</label>
                    <button className="bf-dropdown">
                      <span>{field.value}</span>
                      <ChevronDown size={14} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="bf-grid-row bf-grid-row-single">
                <div className="bf-field">
                  <label className="bf-field-label">Date Range</label>
                  <button className="bf-dropdown bf-date-dropdown">
                    <span>{filters.dateRange}</span>
                    <Calendar size={14} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* VOUCHERS TABLE */}
        <div className="vouchers-table-section">
          <div className="vouchers-tabs-bar">
            {voucherTabs.map((tab) => (
              <button
                key={tab.key}
                className={`vouchers-tab ${
                  activeVoucherTab === tab.key ? "active" : ""
                }`}
                onClick={() => {
                  setActiveVoucherTab(tab.key);
                  setVoucherPage(1);
                  setSelectedRows(new Set());
                }}
              >
                {tab.label}{" "}
                <span className="vouchers-tab-count">{tab.count}</span>
              </button>
            ))}
          </div>
          <div className="vouchers-table-card">
            <div className="vouchers-table-header">
              <h3>{activeTabLabel}</h3>
              {selectedRows.size > 0 && (
                <div className="vouchers-bulk-actions">
                  <span className="vouchers-selected-count">
                    {selectedRows.size} selected
                  </span>
                  <span className="vouchers-bulk-divider">|</span>
                  <span className="vouchers-bulk-label">Bulk actions:</span>
                  <button className="vouchers-bulk-btn vouchers-bulk-activate">
                    <Check size={14} /> Activate
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-pause">
                    <Pause size={14} /> Pause
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-delete">
                    <Trash2 size={14} /> Delete
                  </button>
                  <button
                    className="vouchers-clear-selection"
                    onClick={() => setSelectedRows(new Set())}
                  >
                    <X size={14} /> Clear Selection
                  </button>
                </div>
              )}
            </div>
            <div className="vouchers-table-wrapper">
              <table className="vouchers-data-table">
                <thead>
                  <tr>
                    <th className="vouchers-checkbox-cell">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Promo Name</th>
                    <th>Type</th>
                    <th>Discount</th>
                    <th>Usage Used/Limit</th>
                    <th>Status</th>
                    <th>Validity</th>
                    <th>Assigned To</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPageData.map((v) => {
                    const percent = v.redemptionLimit
                      ? Math.round((v.redemptionUsed / v.redemptionLimit) * 100)
                      : 0;
                    const barColor = percent > 80 ? "red" : "green";
                    const style = statusStyles[v.status] || {
                      bg: "#F3F4F6",
                      color: "#6B7280",
                    };
                    return (
                      <tr key={v.id}>
                        <td className="vouchers-checkbox-cell">
                          <input
                            type="checkbox"
                            checked={selectedRows.has(v.id)}
                            onChange={() => toggleRow(v.id)}
                          />
                        </td>
                        <td className="vouchers-id-cell">{v.id}</td>
                        <td>
                          <span className="vouchers-code-badge">{v.code}</span>
                        </td>
                        <td className="vouchers-name-cell">{v.name}</td>
                        <td>{v.type}</td>
                        <td>{v.discount}</td>
                        <td>
                          <div className="vouchers-remaining-cell">
                            <span>
                              {v.redemptionUsed.toLocaleString()} /{" "}
                              {v.redemptionLimit
                                ? v.redemptionLimit.toLocaleString()
                                : "Unlimited"}
                            </span>
                            {v.redemptionLimit && (
                              <div className="vouchers-remaining-bar-bg">
                                <div
                                  className={`vouchers-remaining-bar-fill vouchers-bar-${barColor}`}
                                  style={{ width: `${percent}%` }}
                                />
                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <span
                            className="vouchers-status-badge"
                            style={{
                              backgroundColor: style.bg,
                              color: style.color,
                            }}
                          >
                            <span
                              className="vouchers-status-dot"
                              style={{ backgroundColor: style.color }}
                            />
                            {v.status}
                            <Info size={12} />
                          </span>
                        </td>
                        <td>{v.validity}</td>
                        <td>{v.assignedTo}</td>
                        <td className="vouchers-lastupdate-cell">
                          <div>{v.lastUpdate}</div>
                          <div className="vouchers-lastupdate-user">
                            {v.updatedBy}
                          </div>
                        </td>
                        <td className="vouchers-action-cell">
                          <FiMoreVertical
                            onClick={() => navigate(`/vouchers/${v.id}`)}
                            size={16}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="vouchers-table-footer">
              <span className="vouchers-showing-text">
                Showing {startIndex + 1} of{" "}
                {Math.min(startIndex + perPage, totalVouchersCount)} of{" "}
                {totalVouchersCount} promo codes
              </span>
              <div className="vouchers-footer-right">
                <select
                  className="vouchers-perpage-select"
                  value={perPage}
                  onChange={(e) => {
                    setPerPage(Number(e.target.value));
                    setVoucherPage(1);
                  }}
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                </select>
                <div className="vouchers-pagination">
                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === 1}
                    onClick={() => setVoucherPage((p) => Math.max(1, p - 1))}
                  >
                    <ChevronLeft size={16} />
                  </button>

                  {pageNumbers.map((n, i) =>
                    n === "..." ? (
                      <span key={i} className="vouchers-page-ellipsis">
                        ...
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`vouchers-page-btn ${
                          voucherPage === n ? "active" : ""
                        }`}
                        onClick={() => setVoucherPage(n)}
                      >
                        {n}
                      </button>
                    ),
                  )}

                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === totalPages}
                    onClick={() =>
                      setVoucherPage((p) => Math.min(totalPages, p + 1))
                    }
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* INSIGHTS SECTION */}
        <div className="voucher-insights-section">
          {/* LEFT COLUMN — 880px */}
          <div className="bdi-left">
            {/* Row 1: Overview cards */}
            <div className="bdi-overview-row">
              {overviewMetrics.map((m, i) => (
                <div className="bdi-overview-card" key={i}>
                  <span className="bdi-overview-title">{m.title}</span>
                  <div className="bdi-overview-value-row">
                    <span className="bdi-overview-value">{m.value}</span>
                    {m.suffix && (
                      <span className="bdi-overview-suffix">{m.suffix}</span>
                    )}
                  </div>
                  <div className="bdi-overview-trend">
                    <ArrowUpRight size={10} className="bdi-trend-arrow" />
                    <span className="bdi-trend-pct">{m.trend}</span>
                    <span className="bdi-trend-text">vs last 30 days</span>
                  </div>
                </div>
              ))}
            </div>
            {/* Row 2: Alerts + AI Insights */}
            <div className="bdi-two-col-row">
              <div className="bdi-panel">
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">Alerts</h4>
                  <span className="bdi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="bdi-alert-list">
                  {bundleAlerts.map((a, i) => (
                    <div className="bdi-alert-row" key={i}>
                      <div className="bdi-alert-left">
                        <div
                          className="bdi-alert-icon-circle"
                          style={{ backgroundColor: a.bg }}
                        >
                          <img
                            src={a.icon}
                            alt={a.title}
                            className="bdi-icon-img bdi-icon-img-lg"
                          />
                        </div>
                        <div className="bdi-alert-text">
                          <span className="bdi-alert-title-text">
                            {a.title}
                          </span>
                          <span className="bdi-alert-desc">{a.desc}</span>
                        </div>
                      </div>
                      <ChevronDown size={18} className="bdi-alert-chevron" />
                    </div>
                  ))}
                </div>
              </div>

              <div className="bdi-panel">
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">AI Insights</h4>
                  <span className="bdi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="bdi-insight-list">
                  {aiInsights.map((a, i) => (
                    <div className="bdi-insight-row" key={i}>
                      <div
                        className="bdi-alert-icon-circle"
                        style={{ backgroundColor: a.bg }}
                      >
                        <img
                          src={a.icon}
                          alt={a.title}
                          className="bdi-icon-img bdi-icon-img-lg"
                        />
                      </div>
                      <div className="bdi-insight-text">
                        <span className="bdi-insight-label">{a.label}</span>
                        <span className="bdi-insight-title">{a.title}</span>
                        <span className="bdi-insight-sub">{a.sub}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Row 3: Bundle Performance Trend */}
            <div className="bdi-panel bdi-trend-panel">
              <div className="bdi-panel-header">
                <h4 className="bdi-panel-title">
                  Bundle Performance Trend{" "}
                  <span className="bdi-panel-sub">(Last 30 Days)</span>
                </h4>
                <div className="bdi-trend-tabs">
                  {trendTabs.map((t, i) => (
                    <button
                      key={t}
                      className={`bdi-trend-tab ${i === 0 ? "bdi-trend-tab-active" : ""}`}
                    >
                      {t}
                    </button>
                  ))}
                </div>
              </div>
              <div className="bdi-trend-chart">
                <ResponsiveContainer width="100%" height={240}>
                  <ComposedChart
                    data={trendData}
                    margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
                  >
                    <CartesianGrid
                      horizontal
                      vertical={false}
                      strokeDasharray="4 4"
                      stroke="#E8E8E8"
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 11, fill: "#474B4E" }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 11, fill: "#474B4E" }}
                      tickFormatter={(v) => (v === 0 ? "0" : `${v / 1000}K`)}
                      domain={[0, 200000]}
                    />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="revenue"
                      stroke="#3FBEAC"
                      strokeWidth={4}
                      dot={false}
                      activeDot={{
                        r: 5,
                        fill: "#3FBEAC",
                        stroke: "#fff",
                        strokeWidth: 2,
                      }}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </div>
            {/* Row 4: Recent Activity */}
            <div className="bdi-panel bdi-activity-panel">
              <div className="bdi-panel-header">
                <h4 className="bdi-panel-title">Recent Activity</h4>
                <span className="bdi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="bdi-activity-table">
                <div className="bdi-activity-head-row">
                  <span className="bdi-col-user">User</span>
                  <span className="bdi-col-action">Action</span>
                  <span className="bdi-col-bundle">Bundle</span>
                  <span className="bdi-col-date">Date</span>
                  <span className="bdi-col-source">Source</span>
                  <span className="bdi-col-details">Details</span>
                </div>
                {recentActivity.map((r, i) => (
                  <div className="bdi-activity-row" key={i}>
                    <div className="bdi-col-user bdi-activity-user">
                      <img
                        src={r.avatar}
                        alt={r.user}
                        className="bdi-activity-avatar"
                      />
                      <div>
                        <div className="bdi-activity-user-name">{r.user}</div>
                        <div className="bdi-activity-user-role">{r.role}</div>
                      </div>
                    </div>
                    <span className="bdi-col-action bdi-pill">{r.action}</span>
                    <span className="bdi-col-bundle">{r.bundle}</span>
                    <span className="bdi-col-date">{r.date}</span>
                    <span className="bdi-col-source">{r.source}</span>
                    <span className="bdi-col-details">{r.details}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Row 5: Bundle Health + Bundle Performance by Sales */}
            <div className="bdi-two-col-row">
              <div className="bdi-panel">
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">Bundle Health</h4>
                </div>
                <div className="bdi-donut-row">
                  <div
                    className="bdi-donut-wrapper"
                    style={{ background: buildConicGradient(bundleHealthData) }}
                  >
                    <div className="bdi-donut-hole">
                      <span className="bdi-donut-total">
                        {bundleHealthTotal}
                      </span>
                      <span className="bdi-donut-total-label">Total</span>
                    </div>
                  </div>
                  <div className="bdi-donut-legend">
                    {bundleHealthData.map((s, i) => (
                      <div className="bdi-legend-row" key={i}>
                        <span
                          className="bdi-legend-dot"
                          style={{ backgroundColor: s.color }}
                        />
                        <span className="bdi-legend-label">
                          {s.label} ({s.count})
                        </span>
                        <span className="bdi-legend-pct">{s.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bdi-panel">
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">
                    Bundle Performance (By Sales)
                  </h4>
                  <span className="bdi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="bdi-bar-chart">
                  <ResponsiveContainer width="100%" height={210}>
                    <BarChart
                      data={bundlesBySalesData}
                      margin={{ top: 10, right: 0, left: -40, bottom: 0 }}
                    >
                      <CartesianGrid
                        vertical={false}
                        strokeDasharray="4 4"
                        stroke="#E8E8E8"
                      />
                      <XAxis
                        dataKey="name"
                        tick={{ fontSize: 9, fill: "#000" }}
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(v) => v}
                        interval={0}
                      />
                      <YAxis
                        tick={{ fontSize: 10, fill: "#000" }}
                        axisLine={false}
                        tickLine={false}
                      />
                      <Bar dataKey="value" radius={[7, 7, 0, 0]} barSize={37}>
                        {bundlesBySalesData.map((entry, i) => (
                          <Cell key={i} fill={entry.color} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT COLUMN — 454px */}
          <div className="bdi-right">
            {[
              { title: "Top Revenue", data: topRevenue },
              { title: "Top Profit", data: topProfit },
            ].map((section, si) => (
              <div className="bdi-panel bdi-list-panel" key={si}>
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">{section.title}</h4>
                  <span className="bdi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="bdi-value-list">
                  {section.data.map((item, i) => (
                    <div className="bdi-value-row" key={i}>
                      <div className="bdi-value-left">
                        <div
                          className="bdi-value-icon-circle"
                          style={{ backgroundColor: item.bg }}
                        >
                          <img
                            src={item.icon}
                            alt={item.name}
                            className="bdi-icon-img bdi-icon-img-sm"
                          />
                        </div>
                        <span className="bdi-value-name">{item.name}</span>
                      </div>
                      <span className="bdi-value-amount">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {[
              { title: "Top Conversion", data: topConversion },
              { title: "Top Sales", data: topSales },
            ].map((section, si) => (
              <div className="bdi-panel bdi-list-panel" key={si}>
                <div className="bdi-panel-header">
                  <h4 className="bdi-panel-title">{section.title}</h4>
                  <span className="bdi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="bdi-value-list">
                  {section.data.map((item, i) => (
                    <div className="bdi-value-row" key={i}>
                      <div className="bdi-value-left">
                        <div
                          className="bdi-value-icon-circle"
                          style={{ backgroundColor: item.bg }}
                        >
                          <img
                            src={item.icon}
                            alt={item.name}
                            className="bdi-icon-img bdi-icon-img-sm"
                          />
                        </div>
                        <span className="bdi-value-name">{item.name}</span>
                      </div>
                      <span className="bdi-value-amount">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="bdi-panel bdi-lowest-panel">
              <div className="bdi-panel-header">
                <h4 className="bdi-panel-title">Lowest Performing</h4>
                <span className="bdi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="bdi-lowest-list">
                {lowestPerforming.map((item, i) => (
                  <div className="bdi-lowest-row" key={i}>
                    <div className="bdi-lowest-left">
                      <div className="bdi-value-icon-circle">
                        <img
                          src={item.icon}
                          alt={item.name}
                          className="bdi-icon-img bdi-icon-img-sm"
                        />
                      </div>
                      <span className="bdi-lowest-name">{item.name}</span>
                    </div>
                    <div className="bdi-lowest-mid">
                      <span className="bdi-lowest-mid-label">Conversion</span>
                      <span className="bdi-lowest-mid-value">
                        {item.conversion}
                      </span>
                    </div>
                    <div className="bdi-lowest-right">
                      <span className="bdi-lowest-right-label">Reason</span>
                      <span
                        className="bdi-reason-pill"
                        style={{
                          backgroundColor: item.reasonBg,
                          color: item.reasonColor,
                        }}
                      >
                        {item.reasonLabel}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bdi-panel bdi-category-panel">
              <div className="bdi-panel-header">
                <h4 className="bdi-panel-title">Bundles by Category</h4>
              </div>
              <div className="bdi-donut-row">
                <div
                  className="bdi-donut-wrapper bdi-donut-small"
                  style={{
                    background: buildConicGradient(bundlesByCategoryData),
                  }}
                >
                  <div className="bdi-donut-hole">
                    <span className="bdi-donut-total">
                      {bundlesByCategoryTotal}
                    </span>
                    <span className="bdi-donut-total-label">Total</span>
                  </div>
                </div>
                <div className="bdi-donut-legend">
                  {bundlesByCategoryData.map((s, i) => (
                    <div className="bdi-legend-row" key={i}>
                      <span
                        className="bdi-legend-dot"
                        style={{ backgroundColor: s.color }}
                      />
                      <span className="bdi-legend-label">{s.label}</span>
                      <span className="bdi-legend-pct">({s.pct}%)</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
